module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='clip-pub-result'>");
      if (this.favicon_url) {
        $o.push("  <div class='column image'>\n    <img src='" + ($e($c(this.favicon_url))) + "'>\n  </div>");
      }
      $o.push("  <div class='column info'>\n    <var>\n      <div class='title'>" + ($e($c(this.name))) + "</div>\n    </var>");
      if (this.domain) {
        $o.push("    <var>\n      <div class='url'>" + ($e($c(this.domain))) + "</div>\n    </var>");
      }
      $o.push("  </div>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/clip_pub_format_result.js.hamlc
// module id = 1317
// module chunks = 17